
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            tools: false
        }  
    },
    computed: {
        ...mapState({
            isSideBarOpen: state => state.sideMenu.isOpen
        })
    },
    methods: {   
        ...mapActions([
            'TOGGLE_SIDE_MENU'
        ]),
        mobile_trigger_tools() {
            this.tools = !this.tools  
        },
        mobile_click_out(e) {
            if(e.target.classList.contains('header-button__angle')) return
            this.tools = false; 
        },
        mobile_close_tools() {
            this.tools = false; 
        },
        mobile_openSidebar() {
            setTimeout(() => {
                this.TOGGLE_SIDE_MENU(!this.isSideBarOpen)    
            }, 1);
        }
    }
}